import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Stack from "@mui/material/Stack"
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import COLORS from 'lib/colors'
import Tooltip from "@mui/material/Tooltip";
import useClipboard from "hooks/useClipboard";


export const CopyValueCell = (params) => {
  const { copyToClipboard } = useClipboard()

  if (!params.value) {
    return ''
  }

  return (
    <Stack direction='row' sx={{ '&:not(:hover) .showOnHover': {visibility: 'hidden'} }}>
      <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{params.value}</Box>

      <Box sx={{ height: '100%' }} className="showOnHover">
        <Tooltip title='Copy'>
          <IconButton aria-label="Copy URL" sx={{ ml: .5, width: '30px', height: '30px' }} onClick={() => copyToClipboard(params.value)}>
            <ContentCopyRoundedIcon sx={{ color: COLORS.slateGray }}/>
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  )
}
